import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrZapArrowUpIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M15.0006 3.53125C15.0004 3.53125 15.0007 3.53125 15.0006 3.53125H9.61602C9.22942 3.53125 8.91602 3.84465 8.91602 4.23125C8.91602 4.61785 9.22942 4.93125 9.61602 4.93125H13.3101L8.48667 9.75191C8.34186 9.89664 8.09782 9.857 8.00627 9.67388L7.09323 7.84782C6.57421 6.80978 5.19066 6.58547 4.37027 7.40636L0.505659 11.2733C0.232373 11.5467 0.232506 11.9899 0.505954 12.2632C0.779403 12.5365 1.22262 12.5364 1.4959 12.2629L5.36051 8.39601C5.50529 8.25115 5.74944 8.29074 5.84104 8.47392L6.75407 10.3C7.2729 11.3376 8.65575 11.5623 9.47633 10.7421L14.301 5.9203V9.61622C14.301 10.0028 14.6144 10.3162 15.001 10.3162C15.3876 10.3162 15.701 10.0028 15.701 9.61622V4.23125C15.701 3.84465 15.3872 3.53125 15.0006 3.53125Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrZapArrowUpIconComponent;
